<template>
  <div class="layout-product-places">
    <div class="tabs">
      <div
        @click="openTab(index)"
        :class="[{ active: index === current }]"
        class="tab"
        v-for="(tab, index) in tabs"
        :key="index"
      >
        <div class="s-14 w-500">{{ tab }}</div>
      </div>
    </div>
    <!--  -->
    <div class="slots-wrapper">
      <div class="s-18 w-500 title">{{ tabs[current] }}</div>
      <div class="slots">

        <div
            v-for="(item, index) in hereLieDown"
            :class="[{ active: index === current }]"
        >
          <iframe :src="item.iframe" width="560" height="400" frameborder="1"
                  allowfullscreen="true" style="position:relative;"></iframe>
          <div class="s-16 w-600">АДРЕС:</div>
          <span v-html="item.adres"></span>
          <div class="s-16 w-600">ВРЕМЯ РАБОТЫ:</div>
          <span v-html="item.working"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      current: 0,
      hereLieDown:[]
    }
  },
  methods: {
    async findContetn(){
      const  hereLieDown  = (
          await this.$axios({
            url: '/ajax/here-lie-down.php',
            method: 'post',
            params: {
              SITE_ID: this.$store.state.siteid
            }
          })
      )
      if (hereLieDown) {
        this.hereLieDown = hereLieDown.data;
      } else {
        console.log('error hereLieDown')
      }
    },
    openTab(index) {
      this.current = index
/*      ;[...this.$el.querySelectorAll(`.slots > div`)].forEach(t => t.classList.remove('active'))
      this.$el.querySelector(`.slots > div:nth-child(${index + 1})`).classList.add('active')*/
    }
  },
  mounted() {
    if (typeof (ym) === "function") {
      let yaCounterId = this.$store.state.langs.YACOUNTER;
      ym(yaCounterId, 'reachGoal', 'map_block_open');
    }
    if(!this.hereLieDown.length) {
      this.findContetn();
    }
    this.openTab(0)
  }
}
</script>

<style lang="scss">
.layout-product-places {
  .tab {
    background: var(--light);
    border-radius: 100px;
    padding: 5px 10px;
    cursor: pointer;
    display: inline-block;
    margin-right: 2px;
    margin-bottom: 2px;
    transition: 0.3s;
    &:hover {
      transform: scale(1.05);
    }
    &.active {
      background: var(--color);
      color: #fff;
    }
  }
  .slots-wrapper {
    padding-top: 15px;
  }
  .title {
    margin-bottom: 15px;
  }
  iframe {
    width: 100%;
    border-radius: 20px;
    margin-bottom: 10px;
  }
  .slots {
    & > div {
      display: none;
      &.active {
        display: block;
      }
    }
  }
}
</style>
